import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const UserLogin = ({ setAuth, setUserType }) => {
  const [dni, setDni] = useState('');  // ← Estado definido
  const [password, setPassword] = useState('');  // ← Estado definido
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/user/login`, {
        identifier: dni.trim(),   // ← Usa "dni" en lugar de formData.dni
        password: password,       // ← Usa "password" en lugar de formData.password
        remember,
      });

      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('userType', 'user');
      // "Mantener sesión iniciada": si no se marca, App.js cierra la sesión
      // al cerrar el navegador (la marca 'session_alive' dura solo esa sesión del navegador).
      localStorage.setItem('rememberSession', remember ? '1' : '0');
      sessionStorage.setItem('session_alive', '1');
      localStorage.setItem('userData', JSON.stringify(response.data.user));

      setAuth(true);
      setUserType('user');

      if (response.data.user.must_change_password) {
        toast.info('Debes cambiar tu contraseña temporal');
        navigate('/change-password');
        return;
      }

      toast.success('¡Bienvenido!');
      navigate('/user-dashboard');
    } catch (error) {
      const mensaje = error.response?.data?.detail || 'DNI o contraseña incorrectos';
      toast.error(mensaje);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a4d2e] via-[#2d6a4f] to-[#1a4d2e] flex items-center justify-center p-4">
      <div className="bg-[#f5e6d3]/95 backdrop-blur-md rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <h1 className="text-3xl font-bold text-[#1a4d2e] text-center mb-8">Acceso Docente</h1>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <Label>DNI</Label>
            <Input 
              value={dni} 
              onChange={(e) => setDni(e.target.value)} 
              placeholder="Ingrese su DNI" 
              required 
            />
          </div>
          <div>
            <Label>Contraseña</Label>
            <div className="relative">
              <Input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pr-12"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                title={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                className="absolute inset-y-0 right-0 px-3 flex items-center text-[#2d6a4f] hover:text-[#1a4d2e]"
              >
                {showPassword ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l18 18" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                )}
              </button>
            </div>
            <p className="text-xs text-[#2d6a4f] mt-2">* Primer ingreso: 123456</p>
          </div>
          <label className="flex items-center gap-2 cursor-pointer select-none text-sm text-[#1a4d2e]">
            <input
              type="checkbox"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
              className="h-4 w-4 accent-[#1a4d2e]"
            />
            Mantener la sesión iniciada
          </label>
          <Button type="submit" disabled={loading} className="w-full">
            {loading ? 'Validando...' : 'Entrar'}
          </Button>
          <button
              type="button"
              onClick={() => navigate('/admin-login')}
              className="text-green-600/80 hover:text-white text-xl underline decoration-white/20"
            >
              ¿Eres administrador? Ingresa aquí
            </button>
        </form>
      </div>
    </div>
  );
};

export default UserLogin;